import CampaignJobBoardForm from "./CampaignJobBoardForm";

import { AddCampaignJobBoardRequest } from "@/types/request/AddCampaignJobBoardRequest";
import { EditCampaignJobBoardRequest } from "@/types/request/EditCampaignJobBoardRequest";
import { CampaignJobBoardType } from "@/types/response/CampaignJobBoardType";

type EditCampaignJobBoardFormProps = {
  campaignId: string;
  campaignJobBoard: CampaignJobBoardType | undefined;
  clientId?: string;
  clientIntegrationModuleId: string;
  errorMessage?: string | null;
  isSubmitting: boolean;
  onSubmitForm: (payload: EditCampaignJobBoardRequest) => void;
  onSuccess?: () => void;
};

function EditCampaignJobBoardForm({
  campaignId,
  campaignJobBoard,
  clientId,
  clientIntegrationModuleId,
  errorMessage,
  isSubmitting,
  onSubmitForm,
  onSuccess
}: EditCampaignJobBoardFormProps) {
  const handleSubmit = (payload: AddCampaignJobBoardRequest) => {
    const updatePayload: EditCampaignJobBoardRequest = {
      campaignId,
      clientIntegrationModuleId,
      endDate: payload.endDate,
      monthlyBudget: payload.monthlyBudget,
      startDate: payload.startDate,
    };
    onSubmitForm(updatePayload);
  };

  return (
    <CampaignJobBoardForm
      campaignId={campaignId}
      campaignJobBoard={campaignJobBoard}
      clientId={clientId}
      errorMessage={errorMessage}
      isEdit={true}
      isSubmitting={isSubmitting}
      onSubmitForm={handleSubmit}
      onSuccess={onSuccess}
    />
  );
}

export default EditCampaignJobBoardForm; 